module.exports = __webpack_public_path__ + "static/media/wf.8bad3190.svg";